import type { TourEnv } from '../config/types';

/**
 * Resolve the current runtime environment for tour config.
 *
 * This app declares its environment via `VITE_ENV_HOOK` (localhost | dev | qa |
 * staging | prod) rather than Vite's build `MODE` (which can differ — e.g. a
 * `development` build that reports itself as `staging`). We read VITE_ENV_HOOK first
 * and fall back to MODE. Unknown values fall back to `production` — the most
 * restrictive bucket — so a misconfiguration never shows an in-progress tour to
 * real users.
 */
export function resolveEnv(): TourEnv {
  const env = (import.meta as unknown as { env?: Record<string, string> }).env || {};
  const raw = String(env.VITE_ENV_HOOK || env.MODE || '').toLowerCase();

  switch (raw) {
    case 'localhost':
      return 'localhost';
    case 'dev':
    case 'development':
      return 'development';
    case 'qa':
      return 'qa';
    case 'staging':
      return 'staging';
    case 'prod':
    case 'production':
      return 'production';
    default:
      return 'production';
  }
}
